<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="form-body without-side">
            <div class="img-holder">
                <div class="info-holder">
                    <img src="../../assets/images/graphic3.svg" alt="">
                </div>
            </div>
            <div class="form-holder mt-5">
                <div class="form-content">
                    <div class="form-items shadow">
                        <div class="website-logo">
                            <router-link to="/">
                                <div class="logo">
                                    <img class="logo-size" v-bind:src="imageLogoPath + data.slider_background" alt="">
                                </div>
                            </router-link>
                        </div>
                        <h3>{{verifyAccountMsg}}</h3>
                       
                        <div class="page-links">
                            <router-link to="/login">Back To Login</router-link >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    export default {
        name: "verifyAccount",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                verifyAccountMsg: "Verification running...",
                fullPage: true,
                loader: "bars",
                accountVerifyURL: "api/verify-account",
                userEmail: "",
                data: [],
                imagePath: this.$api + "upload/header_logo/",
                imageLogoPath: this.$api + "upload/slider_background/"
            }
        },
        created() {
            document.title = 'Geek Buy Back - Verify Account';
            this.getHeaderData();
            this.accountVerifySync();
        },
        methods:{
            accountVerifySync: function(){
                try{
                    this.verifyAccountMsg="Account verification running...";
                    this.isLoading = true;
                    this.$axios.post(this.$api + this.accountVerifyURL, 
                    { passwordToken: this.$route.params.passwordToken }, 
                    {
                    headers: 
                    {
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "*",
                            "Access-Control-Allow-Headers": "*"
                    }     
                    }).then(response => {
                        let row = response.data;
                        console.log('Row = ', row);
                        this.verifyAccountMsg=row.message;
                        this.isLoading = false;
                        console.log(row);
                        //return row;
                        if(row.status == 0) {
                            this.showMessage('error', 'Unable to verify your account', row.message);
                            this.verifyAccountMsg=row.message;
                            this.$router.push("/login");
                            //return false;
                        }
                        else if(row.status == 1) {
                            console.log("Worked Log");
                            this.formData.userEmail = "";
                            let userLogged = "Account Verification";
                            this.verifyAccountMsg=row.message;
                            this.$router.push("/login");
                            this.showMessage('success', userLogged, row.message);
                            this.$router.push("/login");
                            //return false;
                        }
                    })
                    .catch(e => {
                        this.isLoading = false;
                    });

                } catch (ex) {
                    console.log('ex = ', ex);
                }
            },
            getHeaderData: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + "api/geek-site"
                };
                this.$axios(config).then((response) => {
                    if(response.data.status == "success") {
                        this.data = response.data.data;
                    }
                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                    this.isLoading = false;
                });
            },
            showMessage: function(typeMessage, title, detailMessage) {
                this.$swal.fire(
                    title,
                    detailMessage,
                    typeMessage
                );
                return false;
            },
            checkFieldValidation: function(fieldName) {
                if(typeof(fieldName) != 'undefined') {
                    if(fieldName == null) {
                        return true;
                    }
                    else if(fieldName.length == 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            accountVerify: function() {
                this.isLoading = true;
                this.$axios.post(this.$api + this.accountVerifyURL, 
                { passwordToken: this.$route.params.passwordToken }, 
                {
                   headers: 
                   {
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "*",
                        "Access-Control-Allow-Headers": "*"
                   }     
                }).then(response => {
                    let row = response.data;
                    console.log('Row = ', row);
                    this.isLoading = false;
                    console.log(row);
                    if(row.status == 0) {
                        this.showMessage('error', 'Unable to verify your account', row.message);
                        this.verifyAccountMsg=row.message;
                        this.$router.push("/login");
                        return false;
                    }
                    else if(row.status == 1) {
                        this.formData.userEmail = "";
                        let userLogged = "Account Verification";
                        this.verifyAccountMsg=row.message;
                        this.showMessage('success', userLogged, row.message);
                        this.$router.push("/login");
                        return false;
                    }
                })
                .catch(e => {
                    this.isLoading = false;
                    console.log(e);
                });
            },
        }
    }
</script>